export default __webpack_public_path__ + "static/media/moderator.141bf18b.svg";